import React, { useEffect, useState } from "react";
import "../styles/landingPage.css";
import logo from "../images/logo.png";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import corfubarberlottie from "../lotties/CorfuBarber.lottie";

export default function LandingPage() {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const changeLang = (lng) => {
  navigate(`/${lng}`);
};

  const API_URL = process.env.REACT_APP_API_URL;
  
  const [date, setDate] = useState("");
  const [slots, setSlots] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const showMessage = (type, message) => {
    setStatus({ type, message });
    setTimeout(() => setStatus(null), 5000);
  };

  const isValidEmail = (value) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const bookNow = async () => {
    if (
      !date ||
      !selectedTime ||
      !name.trim() ||
      !phone.trim() ||
      !email.trim()
    ) {
      showMessage(
        "error",
        t("errors.required")
      );
      return;
    }

    if (!isValidEmail(email)) {
      showMessage("error", t("errors.invalidEmail"));
      return;
    }

    setIsLoading(true);
    setStatus(null);

    try {
      await axios.post(`${API_URL}/book`, {
        date,
        time: selectedTime,
        name: name.trim(),
        phone: phone.trim(),
        email: email.trim(),
      });

      setSlots((current) => current.filter((s) => s !== selectedTime));

      setSelectedTime(null);
      setName("");
      setPhone("");
      setEmail("");

      showMessage("success", t("success.booked"));

      const res = await axios.get(
        `${API_URL}/availability?date=${date}`
      );
      setSlots(res.data);
    } catch (error) {
      const errorMsg =
        error.response?.data?.error ||
        "Προέκυψε πρόβλημα. Δοκιμάστε ξανά.";
      showMessage("error", errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const sections = document.querySelectorAll(".section");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.2 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  const { lang } = useParams();

  useEffect(() => {
    if (lang && ["en", "el", "it", "de"].includes(lang)) {
      i18n.changeLanguage(lang);
      localStorage.setItem("lang", lang);
    }
  }, [lang]);

  const isPastDate = (dateStr) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const selected = new Date(dateStr);
  selected.setHours(0, 0, 0, 0);

  return selected < today;
};

const filterRealisticSlots = (dateStr, slots) => {
  if (!dateStr) return [];

  // Past day → nothing
  if (isPastDate(dateStr)) return [];

  const now = new Date();

  // Not today → return all
  const todayStr = now.toISOString().split("T")[0];
  if (dateStr !== todayStr) return slots;

  // Today → only future times
  return slots.filter((slot) => {
    const [h, m] = slot.split(":").map(Number);
    const slotTime = new Date();
    slotTime.setHours(h, m, 0, 0);

    return slotTime > now;
  });
};


  return (
    <div className="page">
      <section className="hero">
        <img src={logo} alt="Koypeio Barber Shop Logo" className="logo" />
        <div
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            display: "flex",
            gap: "8px",
            background: "rgba(0,0,0,0.6)",
            padding: "6px 10px",
            borderRadius: "999px",
            backdropFilter: "blur(6px)",
            border: "1px solid rgba(201,162,77,0.3)"
          }}
        >
          {["en", "el", "it", "de"].map((lng) => (
            <button
              key={lng}
              onClick={() => changeLang(lng)}
              style={{
                padding: "6px 12px",
                borderRadius: "999px",
                border: "none",
                cursor: "pointer",
                fontSize: "0.8rem",
                fontWeight: "600",
                letterSpacing: "0.5px",
                color: "#c9a24d",
                background: "transparent",
                transition: "all 0.25s ease"
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#c9a24d";
                e.target.style.color = "#000";
                e.target.style.transform = "scale(1.05)";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#c9a24d";
                e.target.style.transform = "scale(1)";
              }}
            >
              {lng.toUpperCase()}
              
            </button>
          ))}
        </div>
        <h1>{t("hero.title")}</h1>

        <p>{t("hero.selectDate")}</p>

        <div className="Phone-Wrapper">
          <div className="calendar-icon"></div>
          <input
          type="date"
          min={new Date().toISOString().split("T")[0]}
          onChange={async (e) => {
            const d = e.target.value;
            setDate(d);
            setSelectedTime(null);

            document.querySelector(".calendar-icon")?.classList.add("hide-icon");

            if (d) {
              try {
                const res = await axios.get(
                  `${API_URL}/availability?date=${d}`
                );
                setSlots(filterRealisticSlots(d, res.data));
              } catch {
                showMessage(
                  "error",
                  "Αδυναμία φόρτωσης διαθέσιμων ωραρίων"
                );
                setSlots([]);
              }
            } else {
              setSlots([]);
            }
          }}
          style={{ padding: "14px 18px", 
            fontSize: "1.1rem", 
            backgroundColor: "#1a1a1a", 
            color: "#f5f5f5", 
            border: "2px solid #c9a24d44", 
            borderRadius: "12px", 
            width: "220px", 
            cursor: "pointer", 
            outline: "none", 
            transition: "all 0.25s ease", 
            boxShadow: "0 4px 15px rgba(0,0,0,0.5)", 
            margin: "20px 0", }}
        />

        </div>
        <div
          style={{
            marginTop: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            alignItems: "center",
          }}
        >
          <input
            type="text"
            placeholder={t("form.name")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{ padding: "14px 18px", 
              fontSize: "1.1rem", 
              backgroundColor: "#1a1a1a", 
              color: "#f5f5f5", 
              border: "2px solid #c9a24d44", 
              borderRadius: "12px", 
              width: "280px", 
              outline: "none" }}
          />

          <input
            type="tel"
            placeholder={t("form.phone")}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            style={{ padding: "14px 18px", 
              fontSize: "1.1rem", 
              backgroundColor: "#1a1a1a", 
              color: "#f5f5f5", 
              border: "2px solid #c9a24d44", 
              borderRadius: "12px", 
              width: "280px", 
              outline: "none" }}
          />

          <input
            type="email"
            placeholder={t("form.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ padding: "14px 18px", 
              fontSize: "1.1rem", 
              backgroundColor: "#1a1a1a", 
              color: "#f5f5f5", 
              border: "2px solid #c9a24d44", 
              borderRadius: "12px", 
              width: "280px", 
              outline: "none" }}
          />

          <div
            style={{
              marginTop: "16px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "12px",
            }}
          >
            {slots.length > 0 ? (
              slots.map((slot) => (
                <button
                  key={slot}
                  onClick={() => setSelectedTime(slot)}
                  style={{
                    padding: "12px 20px",
                    background:
                      selectedTime === slot ? "#c9a24d" : "#4caf50",
                    color:
                      selectedTime === slot ? "#000" : "#000",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  {slot}
                </button>
              ))
            ) : date ? (
              <p style={{ color: "#ff9800" }}>
                t("availability.none")
              </p>
            ) : null}
          </div>
        </div>

        {status && (
          <div
            style={{
              padding: "12px 20px",
              margin: "16px auto",
              maxWidth: "500px",
              borderRadius: "8px",
              fontWeight: "500",
              backgroundColor:
                status.type === "success"
                  ? "rgba(76, 175, 80, 0.25)"
                  : "rgba(244, 67, 54, 0.25)",
              color:
                status.type === "success" ? "#4caf50" : "#f44336",
              border: `1px solid ${
                status.type === "success" ? "#4caf50" : "#f44336"
              }`,
              textAlign: "center",
            }}
          >
            {status.message}
          </div>
        )}

        <button
          onClick={bookNow}
          disabled={isLoading}
          className="book-button"
          style={{
            opacity: isLoading ? 0.7 : 1,
            cursor: isLoading ? "not-allowed" : "pointer",
          }}
        >
          {isLoading ? t("buttons.loading") : t("buttons.book")}
          <DotLottieReact 
            src={corfubarberlottie}
            autoplay
            loop
            className={"bookingLottie"}
          />
        </button>

      </section>

      {/* ABOUT */}
      <section className="section">
        <div className="image-placeholder"></div>
        <div className="text">
          <h2>{t("about.title")}</h2>
          <p>
            {t("about.desc")}
          </p>
        </div>
      </section>

      {/* HOURS */}
      <section className="section dark wrapper">
        <div>
          <h2>{t("hours.title")}</h2>
          <ul className="hours">
            <li>{t("hours.day1")}: 8:30 – 15:00</li>
            <li>{t("hours.day2")}: 8:30 – 14:30 & 16:30 – 21:00</li>
            <li>{t("hours.day3")}: 8:30 – 15:00</li>
            <li>{t("hours.day4")}: 8:30 – 14:30 & 16:30 – 21:00</li>
            <li>{t("hours.day5")}: 8:30 – 14:30 & 16:30 – 21:00</li>
            <li>{t("hours.day6")}: 8:30 – 15:00</li>
          </ul>
        </div>
        <div className="vertical-image-placeholder"></div>
      </section>

      {/* GALLERY */}
      <section className="section gallerysection">
        <h2>{t("gallery.title")}</h2>
        <div className="gallery">
          <div className="image-placeholder"></div>
          <div className="image-placeholder"></div>
          <div className="image-placeholder"></div>
          <div className="image-placeholder"></div>
        </div>
      </section>

      {/* CONTACT */}
      <section className="section dark">
        <h2>{t("contact.title")}</h2>
        <p>📍 <a href="https://maps.app.goo.gl/G1HLrzjPguU5zAvX6" target="_blank" style={{fontSize:"18px", color:"white"}}>Ιουλίας Ανδεάδη 22</a></p>
        <p> 📸 Instagram <a href="https://www.instagram.com/cfu.barber.shop/" target="_blank" style={{fontSize:"18px", color:"white"}}>cfu.barber.shop</a></p>
        <p style={{fontSize:"18px"}}>📞 6975891913</p>
      </section>

      <footer>
        © {new Date().getFullYear()} Κουρείο Barber Shop, designed & created by{" "}
        <a href="https://cytechsharp.com.cy" target="_blank" rel="noreferrer" style={{color:"white"}} >
          CyTechSharp
        </a>
      </footer>
    </div>
  );
}
